import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LongFormTemplatesSettings from './LongFormTemplatesSettings.tsx';

const queryClient = new QueryClient();

export default function LongFormTemplates({ territoriesForSelect }) {
  return (
    <QueryClientProvider client={queryClient}>
      <LongFormTemplatesSettings territoriesForSelect={territoriesForSelect} />
    </QueryClientProvider>
  );
}
